export const administrationAccountsDepartmentEquipment = {
    template: require('./administration-accounts-department-equipment.html'),
    controller: 'AdministrationAccountsDepartmentEquipmentController'
};
